<template>
  <div class="is-relative">
    <transition name="fade">
      <p
        v-show="!isLittleScroll"
        class="mb-1 all-ease-in-out label-12"
        :class="[{ 'transition-margin-top': isLittleScroll }]"
      >
        Filter Status
      </p>
    </transition>
    <b-dropdown
      ref="dropdownStatusReport"
      ariaStatusReport="menu"
      append-to-body
      position="is-bottom-left"
      :close-on-click="false"
      @active-change="handleClickDropdown"
    >
      <template #trigger>
        <div class="input-filter-specific" :class="[classInput]" :style="{ minWidth: width }">
          <div class="flex-center">
            <div class="flex-center filter-funnel-icon">
              <FilterFunnel />
            </div>
            <p>
              {{ selectedStatus && selectedStatus.title ? selectedStatus.title : 'Semua Status' }}
            </p>
            <div
              v-if="selectedStatus && selectedStatus.title"
              class="close-wrapper"
              @click="handleClearFilter"
            >
              <XMarkIcon size="10" color="#000" />
            </div>
          </div>
        </div>
      </template>
      <p class="averta-bold ml-3 mt-2 mb-1">Pilih Status</p>
      <div class="item-dropdown-report is-flex averta-reguler">
        <div class="parent-status">
          <div
            v-for="(item, index) in groupingData"
            :key="index"
            class="item-title flex-center-vertical is-justify-content-space-between"
            :class="{ active: item.id === selectedTitleID }"
            @click="handleSelectParent(item.id)"
          >
            <p :class="{ 'averta-bold': item.id === selectedTitleID }">{{ item.title }}</p>
          </div>
        </div>
        <div class="child-status">
          <div
            v-for="(item, index) in groupingDataChild"
            :key="index"
            class="child-title flex-center-vertical is-justify-content-space-between"
            :class="{ active: selectedStatus && item.title === selectedStatus.title }"
            @click="handleSelectStatus(item)"
          >
            <p :class="{ 'averta-bold': selectedStatus && item.title === selectedStatus.title }">
              {{ item.title }}
            </p>
            <div
              class="radio-circle"
              :class="{ active: selectedStatus && item.title === selectedStatus.title }"
            ></div>
          </div>
        </div>
        <!-- <div v-for="(item, index) in dataStatus" :key="index">
          <b-radio
            v-model="selectedStatus"
            class="radio-item-report px-3"
            :native-value="item"
            type="is-danger"
          >
            <p class="averta-reguler">{{item.title}}</p>
          </b-radio>
        </div> -->
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DropdownStatusReport',
  props: {
    width: {
      type: String,
      default: '225px'
    },
    isLittleScroll: {
      type: Boolean,
      default: false
    },
    classInput: {
      type: String,
      default: ''
    }
  },
  components: {
    XMarkIcon: () => import('@/components/icons/XMarkIcon.vue'),
    FilterFunnel: () => import('@/components/icons/FilterFunnel.vue')
  },
  computed: {
    ...mapGetters({
      dataStatus: 'report/getDataNavbarReportProgress'
    }),
    groupingData () {
      const groups = {
        Survey: [
          'Survey Diminta',
          'Survey Terjadwal',
          'Survey Dilakukan',
          'Proses SM',
          'Proses Purchasing',
          'Proses BS',
          'Penawaran Terkirim',
          'Penawaran Ditolak'
        ],
        Penawaran: [
          'Penawaran Disetujui',
          'SPK SIK Diterima',
          'Persiapan Material Purchasing',
          'Proyek Dibuat'
        ],
        'Pengerjaan & Pembayaran': [
          'Assign Tukang',
          'Proyek Berlangsung',
          'Pekerjaan Selesai',
          'Konfirmasi Pekerjaan Selesai',
          'Invoice Terkirim',
          'Pembayaran'
        ]
      }

      const groupedData = Object.entries(groups).map(([groupTitle, titles], index) => {
        return {
          id: index + 1,
          title: groupTitle,
          data: this.dataStatus.filter((item) => titles.includes(item.title))
        }
      })
      return groupedData
    },
    groupingDataChild () {
      const result = this.groupingData.filter((item) => item.id === this.selectedTitleID)
      if (result.length > 0) {
        return result[0].data
      }
      return result
    }
  },
  data () {
    return {
      selectedTitleID: 1,
      selectedStatus: null,
      dataChild: [],
      cancelClicked: false
    }
  },
  methods: {
    handleClearFilter () {
      this.selectedStatus = null

      let reset = false
      const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
      if (isFiltered) {
        reset = true
      }
      this.$emit('selected', { data: null, type: 'status', reset })

      this.cancelClicked = true
      this.$emit('clickedDropdown', true)
      setTimeout(() => {
        this.cancelClicked = false
      }, 200)

      setTimeout(() => {
        if (this.$refs.dropdownStatusReport.isActive) {
          this.$refs.dropdownStatusReport.toggle()
        }
      }, 200)
    },
    handlePageRefresh () {
      localStorage.setItem('report_status', JSON.stringify(this.selectedStatus))
    },
    handleClickDropdown (value) {
      if (!this.cancelClicked) {
        this.$emit('clickedDropdown', value)
      }
    },
    handleSelectParent (id) {
      this.selectedTitleID = id
    },
    handleSelectStatus (data) {
      this.selectedStatus = data
    }
  },
  created () {
    const temp = localStorage.getItem('report_status')
    if (temp && JSON.parse(temp)) {
      this.selectedStatus = JSON.parse(temp)
      this.$emit('selected', { data: this.selectedStatus, type: 'status' })
    }
    window.addEventListener('beforeunload', this.handlePageRefresh)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handlePageRefresh)
  },
  watch: {
    selectedStatus (val) {
      this.$emit('selected', { data: val, type: 'status' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.filter-funnel-icon {
  margin-left: -5px;
  margin-right: 3px;
}

.input-filter-specific {
  border: 1px solid #e1e1e1;
  padding: 10px;
  padding-right: 23px;
  border-radius: 5px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
}

.close-wrapper {
  position: absolute;
  right: 8px;
  margin-top: -1px;
}

.item-dropdown-report {
  background: white;
  width: 36em;
  height: 11em;
  /* border-radius: 10px;
  display: grid;
  grid-template-rows: repeat(5, auto);
  grid-auto-flow: column; */
}

.item-dropdown-report label {
  display: flex;
  align-items: center;
}

.parent-status {
  width: 35%;
  border-right: 1px solid #e1e1e1;

  .item-title {
    height: 58.9px;
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #e1e1e1;

    &:hover,
    &.active {
      background: #fff5f6;
    }
  }
}

.child-status {
  width: 65%;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 60px;

  .child-title {
    height: 58.9px;
    padding: 8px 12px;
    border-bottom: 1px solid #e1e1e1;
    cursor: pointer;

    &:hover,
    &.active {
      background: #fff5f6;
    }
  }
}

.radio-item-report {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 12em;
  height: 50px;
  margin-right: 0 !important;
}

.radio-item-report:hover,
.radio-item-report:active {
  background: #e100091a;
}

.radio-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #e1e1e1;
  flex-shrink: 0;
  transition: background 0.2s ease-in-out;
  position: relative;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #3185fc;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }

  &.active {
    background: white;

    &::after {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
